import React from 'react';
import { Chat, Users, LockLocked } from '@wix/wix-ui-icons-common/lazy';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { MarqueeBanner } from '../MarqueeBanner';
const KEY_PREFIX = 'domains_search_suite.anon_storefront_results.optimizations.container.banner.trust_builder';
export const AnimatedBanner = () => {
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  const items = [{
    id: 'support',
    Icon: Chat,
    text: t(`${KEY_PREFIX}.support`)
  }, {
    id: 'users',
    Icon: Users,
    text: t(`${KEY_PREFIX}.users`)
  }, {
    id: 'ssl',
    Icon: LockLocked,
    text: t(`${KEY_PREFIX}.ssl`)
  }];
  return /*#__PURE__*/React.createElement(MarqueeBanner, {
    items: items,
    dataHook: "results-animated-banner",
    coloredItems: true,
    sizedIcon: true
  });
};
//# sourceMappingURL=AnimatedBanner.js.map